<!-- confirmation-modal.component.html -->
<div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
  </div>
  <div class="modal-body">
    <p>Do you want to proceed with the non-refundable room?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">No</button>
    <button type="button" class="btn btn-primary" (click)="modal.close(true)">Yes</button>
  </div>
  
